var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52925 6.19526C3.7896 5.93491 4.21171 5.93491 4.47206 6.19526L8.00065 9.72386L11.5292 6.19526C11.7896 5.93491 12.2117 5.93491 12.4721 6.19526C12.7324 6.45561 12.7324 6.87772 12.4721 7.13807L8.47206 11.1381C8.21171 11.3984 7.7896 11.3984 7.52925 11.1381L3.52925 7.13807C3.2689 6.87772 3.2689 6.45561 3.52925 6.19526Z",
    fill: "#0B0B17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSmall);
export default __webpack_public_path__ + "static/media/arrow-small.d01a81d718e8d07ec9872e06d19fb017.svg";
export { ForwardRef as ReactComponent };